import { CoreContext } from 'context/CoreContext'
import React, { useContext, useMemo, useState } from 'react'

import {
  CompanyButtonContainer,
  InputContainer,
  ModalContainer,
  ShareRow,
  ShareLinkBox,
  CopyButton,
  HelperText,
  CopiedText,
  FormText
} from './styled'
import Wrapper from '../Wrapper'
import Button from 'components/Form/Button'
import useI18n from 'hooks/useI18n'
import { Icon } from 'ui/styled'

export default function ModalShare() {
  const { modal, setModal } = useContext(CoreContext)
  const { t } = useI18n()

  const [copied, setCopied] = useState(false)
  const days = modal?.days || 7

  const close = () => setModal(null)

  const shareUrl = useMemo(() => {
    if (!modal?.token) return ''
    return `${window.location.origin}/share/${modal.token}`
  }, [modal?.token])

  const copyLink = async () => {
    if (!shareUrl) return

    try {
      await navigator.clipboard.writeText(shareUrl)
    } catch {
      const input = document.createElement('input')
      input.value = shareUrl
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
    }

    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  const withDays = (key) => {
    const text = t(key)
    return typeof text === 'string' ? text.replace('{days}', String(days)) : text
  }

  return (
    <Wrapper
      title={t('share_link')}
      text={withDays('share_link_description')}
    >
      <ModalContainer>
        <InputContainer>
          <FormText>{t('share_link_label')}</FormText>
          <ShareRow>
            <ShareLinkBox title={shareUrl}>{shareUrl || 'Loading...'}</ShareLinkBox>

            <CopyButton type="button" onClick={copyLink} disabled={!shareUrl} aria-label={t('copy_link')}>
              <Icon icon="copy" />
            </CopyButton>
          </ShareRow>

          {copied && (<CopiedText>{t('copied')}</CopiedText>)}

          <HelperText>{withDays('share_link_warning')}</HelperText>
        </InputContainer>
      </ModalContainer>

      <CompanyButtonContainer>
        <Button onClick={close} width="120px" outline color="primary" small nospace>
          {t('close')}
        </Button>
        <Button color="blue" onClick={copyLink} width="120px" small between nospace>
          {t('copy')}
        </Button>
      </CompanyButtonContainer>
    </Wrapper>
  )
}
